import React from 'react';
import TemplateAside from './templates/template';
import { createTemplate } from '@/lib/templateSwitch';

export default function Aside() {
  const template = createTemplate(TemplateAside);

  return <>{template}</>;
}
